module.exports = __webpack_public_path__ + "static/media/column-chart-analytics-svgrepo-com.787d3e6e.svg";